<template>
  <div class="footer py-4 mt-10 d-flex flex-lg-column" id="kt_footer">
    <div class="d-flex flex-column-reverse flex-lg-row align-items-center justify-content-between container">
      <div class="nav d-lg-block py-1">
        <span class="footer-text">{{ currentYear }}</span>
        <span class="footer-text">
          ©
          <a :href="CIRX_URL" target="_blank" class="nav-link d-inline p-0">
            {{ translate("FOOTER.CIRCULARX_LINK") }}
          </a>
        </span>
      </div>

      <div class="nav nav-dark order-1 order-lg-2 d-flex flex-column flex-lg-row">
        <router-link
          :to="{ name: routes.organizationCgu.name }"
          id="eula-link"
          target="_blank"
          class="nav-link d-block d-lg-flex pr-lg-3 px-0 py-1 text-center"
        >
          {{ translate("FOOTER_WEB.EULA") }}
        </router-link>

        <router-link
          :to="{ name: routes.organizationCgs.name }"
          id="service-terms-link"
          target="_blank"
          class="nav-link d-block d-lg-flex pr-lg-3 px-0 py-1 text-center"
        >
          {{ translate("FOOTER_WEB.SERVICE_TERMS") }}
        </router-link>

        <router-link
          :to="{ name: routes.organizationFaq.name }"
          id="faq-contact-link"
          target="_blank"
          class="nav-link d-block d-lg-flex pr-lg-3 px-0 py-1 text-center"
        >
          {{ translate("FOOTER_WEB.FAQ_AND_CONTACT") }}
        </router-link>

        <router-link
          :to="{ name: routes.cookiesPolicy.name }"
          id="cookies-policy-link"
          target="_blank"
          class="nav-link d-block d-lg-flex pr-lg-3 px-0 py-1 text-center"
        >
          {{ translate("FOOTER_WEB.COOKIES_POLICY") }}
        </router-link>

        <router-link
          v-if="accessibilityStatementDocumentUrl"
          :to="{ name: routes.accessibilityStatement.name }"
          id="accessibility-statement-link"
          target="_blank"
          class="nav-link d-block d-lg-flex pr-lg-3 px-0 py-1 text-center"
        >
          {{ translate("FOOTER_WEB.ACCESSIBILITY_STATEMENT") }}
        </router-link>
      </div>
    </div>
  </div>
</template>

<script setup>
/* eslint no-unused-vars:off */
import { routes as globalRoutes } from "@/routing/routes.js";
import { routes as whiteLabelRoutes } from "@/apps/whiteLabelWebsite/whiteLabel/routing/routes";
import { CIRX_URL } from "@/core/constants/cirxConstants.js";
import useTranslate from "@/core/composables/translate";
import whiteLabelConfigQuery from "@/apps/whiteLabelWebsite/whiteLabel/core/application/bridge/query/configQuery";

const { translate } = useTranslate();

const routes = {
  organizationCgu: globalRoutes.organizationCgu,
  organizationCgs: globalRoutes.organizationCgs,
  organizationFaq: globalRoutes.organizationFaq,
  cookiesPolicy: whiteLabelRoutes.cookiesPolicy,
  accessibilityStatement: whiteLabelRoutes.accessibilityStatement,
};

const currentYear = new Date().getFullYear();

const accessibilityStatementDocumentUrl = whiteLabelConfigQuery.getConfig().accessibilityStatement;
</script>
